<template>
  <div class="c-level-select">
    <div class="c-level-select__wrapper">
      <span class="c-level-select__label">{{ $t('LEVEL_SELECT_LABEL') }}</span>
      <div class="c-level-select__box">
        <a
          v-for="item in levels"
          :key="item.url"
          :href="composeUrl(item)"
          :tabindex="!item.url ? '-1' : '0'"
          class="c-level-select__level-link"
          :class="{ 'active': item.current, 'disabled': !item.url }"
        >
          <span>
            {{ item.level }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  setup(props, { root }) {
    const levels = computed(() => root.$store.getters['appConfig/getAppLevels'])
    const composeUrl = item => {
      if (!item.url) return '#'
      if (root.$store.getters['appConfig/isTeacher']) {
        return `${item.url}?role=teacher`
      }

      return item.url
    }

    return {
      composeUrl,
      levels
    }
  }
}
</script>
